<template>
  <section class="Cart-Summary">
    <h4 class="Cart__Title h4">{{ store.terms.title }}</h4>
    <template v-if="store.tieredDiscountsEnabled">
      <PromotionalTile />
    </template>
    <template v-else>
      <ProgressBar :show-free-shipping-copy="props.showFreeShippingCopy" />
      <Suspense>
        <GiftWithPurchase />
      </Suspense>
    </template>
    <CartUrgency />
    <ul class="Cart__Items">
      <LineItem
        v-for="item in props.items"
        :ready="store.promoReady"
        :item="item"
        :items="props.items"
        :key="item"
      />
    </ul>
  </section>
</template>

<script setup>
import LineItem from './LineItem.vue';
import CartUrgency from './CartUrgency.vue';
import ProgressBar from './ProgressBar.vue';
import GiftWithPurchase from './GiftWithPurchase.vue';
import PromotionalTile from './PromotionalTile.vue';

import { useCartStore } from './Composables/Store';

const store = useCartStore();

const props = defineProps({
  items: Array,
  showFreeShippingCopy: {
    type: [String, Boolean],
    default: false,
  },
});
</script>
